/**
 * Theme Settings Utility
 * Provides easy access to theme settings from DOM data attributes
 */

class ThemeSettings {
  static getSetting(key, defaultValue = null) {
    const body = document.body;

    if (!body) return defaultValue;

    const dataKey = this.camelToKebab(key).replace(/_/g, '-');
    const value = body.getAttribute(`data-${dataKey}`);

    if (value === null) return defaultValue;

    // Try to parse as number if it looks like one
    if (!isNaN(value) && !isNaN(parseFloat(value))) {
      return parseFloat(value);
    }

    // Try to parse as boolean
    if (value === 'true') return true;
    if (value === 'false') return false;

    // Return as string
    return value;
  }

  static getFreeShippingThreshold() {
    return this.getSetting('free_shipping_threshold', 12);
  }

  static getFreeShippingMessage(type) {
    if (type === 'below') {
      return this.getSetting('free_shipping_message_below', '');
    } else {
      return this.getSetting('free_shipping_message_above', '');
    }
  }

  static getAllSettings() {
    const body = document.body;
    if (!body) return {};

    const settings = {};
    const attributes = body.attributes;

    for (let i = 0; i < attributes.length; i++) {
      const attr = attributes[i];
      if (attr.name.startsWith('data-')) {
        const key = this.kebabToCamel(attr.name.substring(5));
        settings[key] = this.parseValue(attr.value);
      }
    }

    return settings;
  }

  static parseValue(value) {
    if (value === null || value === undefined) return null;

    // Try to parse as number
    if (!isNaN(value) && !isNaN(parseFloat(value))) {
      return parseFloat(value);
    }

    // Try to parse as boolean
    if (value === 'true') return true;
    if (value === 'false') return false;

    // Return as string
    return value;
  }

  static camelToKebab(str) {
    return str.replace(/([A-Z])/g, '-$1').toLowerCase();
  }

  static kebabToCamel(str) {
    return str.replace(/-([a-z])/g, (match, letter) => letter.toUpperCase());
  }

  // Cart & Shipping specific methods
  static getCartSettings() {
    return {
      freeShippingThreshold: this.getFreeShippingThreshold(),
      freeShippingMessageBelow: this.getFreeShippingMessage('below'),
      freeShippingMessageAbove: this.getFreeShippingMessage('above'),
    };
  }
}

// Export for use in other scripts
window.ThemeSettings = ThemeSettings;
